window.GenLoader = (function () {
  const cache = {};
  const assets = () => window.GenAssets || {};

  return {
    load(nameOrUrl) {
      const src = assets()[nameOrUrl] || nameOrUrl;

      if (!src) {
        return Promise.reject(new Error("GenLoader: không tìm thấy asset " + nameOrUrl));
      }
      if (cache[src]) return cache[src];

      cache[src] = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = src;
        s.onload = resolve;
        s.onerror = () => {
          delete cache[src];
          reject(new Error("Không tải được " + src));
        };
        document.head.appendChild(s);
      });
      return cache[src];
    },
  };
})();